import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import BlogUpvote from './BlogUpvote'

export default function BlogCard({ post, upvoteCount, hasUpvoted, onUpvote }) {
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  return (
    <motion.article
      className="blog-card"
      whileHover={{ y: -5 }}
      transition={{ duration: 0.2 }}
    >
      <Link to={`/blog/${post.slug}`} className="blog-card-link">
        {post.featuredImage && (
          <div className="blog-card-image-wrapper">
            <img
              src={post.featuredImage}
              alt={post.title}
              className="blog-card-image"
              loading="lazy"
            />
          </div>
        )}

        <div className="blog-card-content">
          <div className="blog-card-categories">
            {post.categories.map(cat => (
              <span key={cat} className="category-badge">{cat}</span>
            ))}
          </div>

          <h3 className="blog-card-title">{post.title}</h3>

          <p className="blog-card-excerpt">{post.excerpt}</p>

          <div className="blog-card-footer">
            <div className="blog-card-meta">
              <span>{formatDate(post.date)}</span>
              <span>{post.readTime} min read</span>
            </div>

            <BlogUpvote
              count={upvoteCount}
              hasUpvoted={hasUpvoted}
              onUpvote={onUpvote}
            />
          </div>
        </div>
      </Link>
    </motion.article>
  )
}
